(()=>{
 const host=document.querySelector('.factory-hero')||document.querySelector('.cinema');
 const video=document.querySelector('#factoryFilm')||document.querySelector('#video')||host?._factoryClock;
 const canvas=host?.querySelector('.optical-sparkles');
 if(!video||!host||!canvas)return;
 const ctx=canvas.getContext('2d'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
 let raf=0,dpr=1,w=0,h=0,moving=false;
 const LOOP_START=15.833333,LOOP_PERIOD=6.666342,REVEAL=13.383333;
 function resize(){
   w=host.clientWidth;h=host.clientHeight;dpr=Math.min(devicePixelRatio||1,2);
   canvas.width=Math.round(w*dpr);canvas.height=Math.round(h*dpr);
   ctx.setTransform(dpr,0,0,dpr,0,0);
   draw();
 }
 function content(){
   const v=video.getBoundingClientRect(),r=host.getBoundingClientRect();
   const scale=Math.min(v.width/(video.videoWidth||1280),v.height/(video.videoHeight||720));
   const cw=(video.videoWidth||1280)*scale,ch=(video.videoHeight||720)*scale;
   return {x:v.left-r.left+(v.width-cw)/2,y:v.top-r.top+(v.height-ch)/2,w:cw,h:ch};
 }
 function flare(x,y,radius,power,angle){
   if(power<.01)return;
   ctx.save();ctx.translate(x,y);ctx.rotate(angle);ctx.globalCompositeOperation='screen';
   const halo=ctx.createRadialGradient(0,0,0,0,0,radius*.38);
   halo.addColorStop(0,`rgba(255,255,255,${power})`);
   halo.addColorStop(.10,`rgba(250,253,255,${power*.85})`);
   halo.addColorStop(.30,`rgba(225,241,255,${power*.23})`);
   halo.addColorStop(1,'rgba(255,255,255,0)');
   ctx.fillStyle=halo;ctx.fillRect(-radius,-radius,radius*2,radius*2);
   for(let i=0;i<6;i++){
     ctx.save();ctx.rotate(i*Math.PI/3);
     const length=radius*(i%3===0?1.25:.6);
     const ray=ctx.createLinearGradient(0,0,length,0);
     ray.addColorStop(0,`rgba(255,255,255,${power})`);
     ray.addColorStop(.17,`rgba(255,255,255,${power*.6})`);
     ray.addColorStop(.65,`rgba(245,252,255,${power*.09})`);
     ray.addColorStop(1,'rgba(255,255,255,0)');
     ctx.fillStyle=ray;ctx.beginPath();ctx.moveTo(0,-Math.max(1,radius*.012));
     ctx.lineTo(length,0);ctx.lineTo(0,Math.max(1,radius*.012));ctx.closePath();ctx.fill();ctx.restore();
   }
   ctx.restore();
 }
 function draw(){
   ctx.clearRect(0,0,w,h);
   if(reduced.matches||video.currentTime<REVEAL||document.hidden)return;
   const c=content(),t=video.currentTime;
   const phase=t>=LOOP_START?(t-LOOP_START)%LOOP_PERIOD:t-REVEAL;
   const theta=phase/LOOP_PERIOD*Math.PI*2;
   const pulses=t>=LOOP_START
     ?[{at:3.25,y:.785,p:1,r:1,a:.1},{at:5.55,y:.82,p:.86,r:.83,a:-.2},{at:1.45,y:.47,p:.47,r:.52,a:.28}]
     :[{at:.82,y:.88,p:.92,r:.9,a:.1}];
   for(const pulse of pulses){
     const envelope=Math.exp(-Math.pow((phase-pulse.at)/.24,2))*pulse.p;
     const x=c.x+c.w*(.5+Math.sin(theta)*.004);
     const y=c.y+c.h*pulse.y;
     const radius=Math.min(c.w*(c.w<c.h?0.26:0.19),280)*pulse.r;
     flare(x,y,radius,envelope,pulse.a+(phase-pulse.at)*.5);
   }
 }
 function tick(){raf=0;draw();if((moving||!video.paused&&!video.ended)&&!document.hidden)raf=requestAnimationFrame(tick)}
 function run(){if(!raf)raf=requestAnimationFrame(tick)}
 for(const event of ['play','seeked','timeupdate','loadedmetadata'])video.addEventListener(event,run);
 video.addEventListener('transitionrun',()=>{moving=true;run()});
 video.addEventListener('transitionend',()=>{moving=false;draw()});
 video.addEventListener('pause',()=>{if(raf)cancelAnimationFrame(raf);raf=0;draw()});
 document.addEventListener('visibilitychange',()=>{if(document.hidden){if(raf)cancelAnimationFrame(raf);raf=0;ctx.clearRect(0,0,w,h)}else run()});
 new ResizeObserver(resize).observe(host);addEventListener('resize',resize,{passive:true});
 reduced.addEventListener('change',draw);resize();
})();
